import React from 'react';
import RatingMui, { RatingProps } from '@material-ui/lab/Rating';

export const Rating: React.FC<RatingProps> = ({ children, ...rest }) => {
	return <RatingMui {...rest} />;
};
